import React, { useState, useEffect } from "react";
import { LoadingOutlined, FileAddOutlined, ContactsOutlined, NodeIndexOutlined } from "@ant-design/icons";
import { Button, Modal, Divider } from 'antd';
import { updateStockManually, sendStockEMail, getStockReport } from "../../../functions/accounts";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";
import { getReplenishInfo } from "../../../functions/inventory";


const HealthTab = ({ p, slug, user, loadData }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [data, setData] = useState({ other: [], suppliers: [] })
    const [loading, setLoading] = useState(false)
    const [quantity, setQuantity] = useState(0)
    const [open, setOpen] = useState(false)
    const [values, setValues] = useState({})
    const history = useHistory()

    const showModal = () => {
        setLoading(true);
        getReplenishInfo(slug, p._id)
            .then((res) => {
                if (res.data) {
                    setOpen(true);
                    setData(res.data);
                    console.log(res.data);
                }
            })
            .catch((error) => {
                // Display the error message using toast
                toast.error(`Error: ${error.message || 'Something went wrong!'}`);
            })
            .finally(() => {
                // Turn off the loading indicator regardless of success or failure
                setLoading(false);
            });
    };

    const handleCancel = () => {
        setOpen(false);
    };




    return (
        <>
            <tbody key={p._id}>
                <tr key={p._id}>
                    <td>{p.productName}</td>
                    <td>{p.totalQuantity}</td>
                    <td>{(p.totalSales).toFixed(2)}

                    </td>
                    <td>{(p.avgSalesPerWeek).toFixed(2)}</td>
                    <td>{p.quantity}</td>
                    <td>{p.endDate}</td>
                    <td style={{ color: p.inventoryStatus === 'Healthy' ? 'green' : 'red' }}>{p.inventoryStatus}</td>
                    <td> {p.inventoryStatus != 'Healthy' && (
                        <>
                            {p.inventoryStatus != 'Overstock' && (
                                <>
                                    {loading ?
                                        <LoadingOutlined /> : <FileAddOutlined onClick={showModal} />

                                    }
                                </>
                            )}
                        </>
                    )} </td>

                </tr>

            </tbody>

            <Modal
                title="Stock Status"
                centered
                visible={open}
                closable={false}
                width={800}
                footer={[
                    <Button
                        onClick={() => {
                            setOpen(false)
                        }}
                        className="button btn button--prime button-width--med text-center">
                        Close
        </Button>
                ]}
            >
                <h4>Store Transfers</h4>
                <table className="table table-bordered">
                    <thead className="thead-light">
                        <tr>
                            <th scope="col">Store</th>
                            <th scope="col">Stock</th>
                            <th scope="col">Option</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.other.map(store => (
                            <tr key={store._id}>
                                <td>{store.storeName}</td>
                                <td>{store.stock}</td>
                                <td>
                                    {store.stock > 0 && (
                                        <Button
                                            onClick={() => {
                                                history.push(`/storecharge/transfer/create?store=${store._id}&&product=${data.barcodeId}`)
                                            }}
                                            className="button btn button--prime button-width--med text-center">
                                            Request
                                        </Button>
                                    )}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>

                <h4>Suppliers</h4>
                <table className="table table-bordered">
                    <thead className="thead-light">
                        <tr>
                            <th scope="col">Supplier Name</th>
                            <th scope="col">Option</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.suppliers.map(supplier => (
                            <tr key={supplier._id}>
                                <td>{supplier.name}</td>
                                <td>
                                    <Button
                                        onClick={() => {
                                            // Implement your logic to generate new PO
                                            history.push(`/storecharge/purchase-order/create?supplier=${supplier._id}`)

                                        }}
                                        className="button btn button--prime button-width--full text-center">
                                        Generate New PO
                        </Button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </Modal>

        </>
    )
}

export default HealthTab
